import Vue from "vue";
import Quill from "vue-quill-editor";
import "quill/dist/quill.snow.css";

Vue.use(Quill);
